export default __webpack_public_path__ + "static/media/placeholder_avatar.4ade8a37.jpeg";